import type { HTMLAttributes, ReactNode } from 'react'

import { Icon } from './Icon'
import styles from './AlertBar.module.css'

export interface AlertBarProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  tone: 'red' | 'orange'
  children: ReactNode
  action?: ReactNode
}

export function AlertBar({ tone, children, action, className = '', ...props }: AlertBarProps) {
  return (
    <div data-component="alert-bar" className={`${styles.bar} ${styles[tone]} ${className}`} {...props}>
      <Icon name="alert" size={18} />
      <span>{children}</span>
      {action}
    </div>
  )
}
